
















import Vue from 'vue';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  props: {
    orderId: {
      type: Number,
      required: true,
    },
    terminate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    title() {
      if (this.terminate) return this.$t('CUSTOMERS.LINK.TERMINATE_ORDER');

      return this.$t('CUSTOMERS.LINK.CANCEL_ORDER');
    },
    description() {
      if (this.terminate)
        return this.$t('CUSTOMERS.TEXT.TERMINATE_ORDER_CONFIRMATION');

      return this.$t('CUSTOMERS.TEXT.CANCEL_ORDER_CONFIRMATION');
    },
  },
  methods: {
    async cancelOrder() {
      try {
        const dispatchPromise = await this.$store.dispatch('sale/cancelOrder', {
          id: this.orderId,
        });
        this.$emit('close');
        this.$emit('onSubmit', dispatchPromise);
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('CUSTOMERS.NOTIFICATIONS.CANCEL_ORDER_SUCCESS'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('CUSTOMERS.NOTIFICATIONS.CANCEL_ORDER_ERROR'),
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
  },
});
